import { ApiService } from './api/api'
import type { Item } from '@/data/schema/item'
import { processParams } from '@/utils/params'

export default class ItemService {
	private apiService: ApiService

	constructor() {
		this.apiService = new ApiService(true)
	}

	getAll(params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`items`, { params: processParams(params) })
	}

	/**
	 * Get the item or sub group from the item code
	 * @param code string
	 * @returns Promise
	 */
	get(code: string): Promise<{ data: { data: Item } }> {
		return this.apiService.get(`items/${code}`)
	}
}
